import { GraphQLClient } from "graphql-request";

import { getSdk } from "@/graphql/storefront/generated";
import { storefrontGraphqlUrl } from "@/consts/shopify-urls";
import { config } from "@/config";

const client = new GraphQLClient(
  storefrontGraphqlUrl(config.shopify.storeDomain),
  {
    headers: {
      "X-Shopify-Storefront-Access-Token": config.shopify.storefrontToken,
    },
  },
);

const GRAPHQL_CLIENT = getSdk(client);

export default GRAPHQL_CLIENT;
